import { indexBy, prop } from 'ramda';

import { createReducer } from 'utils/ReduxUtils';

import { FETCH_LOCKER_TASKS_SUCCESS } from '../../../../appointmentTask/actionTypes';

const initialState = {};

const fetchLockerTasksReducer = (state, { payload, meta }) => {
  const { vaultId: lockerId } = meta;
  return {
    ...state,
    [lockerId]: {
      ...(state[lockerId] ?? {}),
      ids: (payload?.content ?? []).map(({ id }) => id),
      page: payload.page,
      links: indexBy(prop('rel'))(payload.links),
    },
  };
};

export default createReducer(initialState, {
  [FETCH_LOCKER_TASKS_SUCCESS]: fetchLockerTasksReducer,
});
